"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.presetThemes = exports.PresetThemes = void 0;
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
var PresetThemes;
(function (PresetThemes) {
    PresetThemes["Primary"] = "Primary";
    PresetThemes["Neutral"] = "Neutral";
    PresetThemes["ThemeV5Primary"] = "ThemeV5Primary";
    PresetThemes["ThemeV5Neutral"] = "ThemeV5Neutral";
})(PresetThemes = exports.PresetThemes || (exports.PresetThemes = {}));
exports.presetThemes = {
    Primary: {
        color: merlin_theme_1.default.colours.neutral.white,
        bgColor: merlin_theme_1.default.colours.success.primary,
        hoverColor: merlin_theme_1.default.colours.success.misc,
        activeColor: merlin_theme_1.default.colours.success.primary,
    },
    Neutral: {
        color: merlin_theme_1.default.colours.neutral.darkest,
        bgColor: merlin_theme_1.default.colours.neutral.lightest,
        hoverColor: merlin_theme_1.default.colours.neutral.light,
        activeColor: merlin_theme_1.default.colours.neutral.light,
    },
    ThemeV5Primary: {
        color: merlin_theme_1.default.colours.neutral.white,
        bgColor: merlin_theme_1.default.paletteV5.purple.primary,
        hoverColor: merlin_theme_1.default.paletteV5.purple.purple2,
        activeColor: merlin_theme_1.default.paletteV5.purple.primary,
    },
    ThemeV5Neutral: {
        color: merlin_theme_1.default.paletteV5.pink.primary,
        bgColor: merlin_theme_1.default.paletteV5.greyscale.white,
        hoverColor: merlin_theme_1.default.paletteV5.greyscale.gray6,
        activeColor: merlin_theme_1.default.paletteV5.greyscale.white,
    },
};
//# sourceMappingURL=constants.js.map